import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'kodit-filter-name',
  templateUrl: './filter-name.component.html',
  styleUrls: ['./filter-name.component.scss']
})
export class FilterNameComponent implements OnInit {

  @Input() title: string = "";
  constructor() { }

  ngOnInit(): void {
  }

}
